export default {
  //Terms
  Terms: {
    MultipleAssign: 'Giao việc hàng loạt',
    PriorityLevel: 'Mức độ ưu tiên',
    TaskType: 'Loại việc',
    HostPeople: 'Người chủ trì',
    Host: 'Người/Đơn vị chủ trì',
    Related: 'Người/Đơn vị liên quan',
    Cooperator: 'Người/Đơn vị phối hợp',
    DueDate: 'Hạn hoàn thành',
    DirectingDocument: 'Văn bản chỉ đạo',

    Attachments: 'Tệp đính kèm',
    ChildTask: 'Công việc con',
    InputProgress: 'Nhập tiến độ',
    MarkDone: 'Đánh dấu hoàn thành',
    UndoMarkDone: 'Hủy đánh dấu hoàn thành',
  },
  //Placeholder
  Placeholder: {
    PHTaskName: 'Nhập tên công việc',
    PHAddDoc: 'Nhập số văn bản',
    PHSearchbar: 'Tìm kiếm theo tên công việc, số văn bản, thành phần tham gia',
    AllTaskType: 'Tất cả loại việc',
    AllStatus: 'Tất cả tình trạng',
    PagingNullText: `Tổng số: 0 bản ghi (0 công việc cha - 0 công việc con)`,
  },
  //BtnText
  BtnText: {
    BtnHandover: 'Thực hiện điều phối bàn giao',
    BtnAddDoc: 'Nhập văn bản chỉ đạo',
    BtnAddDocList: 'Chọn từ danh sách',
    BtnAddDesc: 'Nhập mô tả',
    BtnAddAssignee: 'Thêm người thực hiện',
    BtnAddAttachment: 'Thêm tệp đính kèm',
    BtnAddSubTask: 'Thêm công việc con',
    BtnCancel: 'Hủy',
    BtnDraft: 'Lưu dự thảo',
    BtnSave: 'Lưu',
    BtnConfirm: 'Xác nhận',
    BtnSend: 'Gửi',
    BtnDeleteDoc: 'Xóa văn bản',
    BtnAddTask: 'Thêm công việc',
    AdvanceFilter: 'Bộ lọc nâng cao',
    ColumnSetting: 'Thiết lập ẩn hiện cột',
    BtnSetDefault: 'Lấy lại mặc định',
  },
  //Title
  Title: {
    AddProgress: 'Tiến độ công việc',
    AddProportion: 'Thiết lập tỷ trọng',
  },
  //Contents
  Contents: {
    NoDataText: 'Chưa có công việc nào, bắt đầu thực hiện công việc ngay nào!',
    MaxProgressNotify: 'Đánh dấu hoàn thành công việc',
    ProportionDesc:
      'Tiến độ hoàn thành của công việc cha được tính theo tỷ trọng được thiết lập dưới đây',
  },
  TaskStatusText: {
    Draft: 'Dự thảo',
    InProgess: 'Chưa hoàn thành',
    Completed: 'Hoàn thành',
    InCompleted: 'Không hoàn thành',
    InProgessLate: 'Chưa hoàn thành trễ hạn',
    CompletedLate: 'Hoàn thành trễ hạn',
  },
  StatusApprovalMissionText: {
    None: '',
    Process: 'Đang xử lý',
    Success: 'Đã phê duyệt',
    Reject: 'Đã trả lại',
  },
};
